<div class="welcome-home">
    <app-products></app-products>
    <app-benefits></app-benefits>
    <app-choose-card></app-choose-card>

    <app-newsletter></app-newsletter>
</div>